import { useState, useCallback } from 'react';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.REACT_APP_NAVIGATE(`/category/all?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  }, [searchQuery]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20theater%20interior%20with%20warm%20orange%20and%20amber%20ambient%20lighting%2C%20empty%20red%20velvet%20seats%2C%20large%20projection%20screen%20with%20soft%20glow%2C%20atmospheric%20haze%2C%20luxurious%20and%20elegant%20movie%20theater%20aesthetic%2C%20no%20people%2C%20rich%20dark%20tones%20with%20golden%20accents&width=1600&height=900&seq=juzi-hero-bg&orientation=landscape"
          alt="桔子视频 - 高清影视在线观看平台"
          title="桔子视频 - 西瓜视频免费在线观看高清全集"
          className="w-full h-full object-cover object-top"
        />
      </div>
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-3 md:mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          西瓜视频 · 丝瓜视频
          <span className="block text-lg md:text-2xl lg:text-3xl font-normal mt-2 text-foreground-200">
            高清全集不缓冲 · 免费在线观看
          </span>
        </h1>
        <p className="text-sm md:text-base text-foreground-300 max-w-2xl mb-6 md:mb-8">
          桔子视频汇聚西瓜视频、丝瓜视频等热门平台资源，提供电视剧大全、电影、综艺、动漫、纪录片高清全集免费在线观看，极速不缓冲，畅享丝滑观影体验
        </p>

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="w-full max-w-xl flex items-center gap-0">
          <div className="flex-1 flex items-center bg-background-50/90 backdrop-blur-sm rounded-l-lg border border-background-200 overflow-hidden">
            <i className="ri-search-line text-foreground-500 ml-4 text-lg"></i>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索你想要的视频..."
              className="flex-1 px-3 py-3 text-sm bg-transparent text-foreground-950 placeholder:text-foreground-500 focus:outline-none"
            />
          </div>
          <button
            type="submit"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-r-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </form>

        {/* Hot Tags */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-5">
          <span className="text-xs text-foreground-400">热门搜索：</span>
          {['繁花', '狂飙', '三体', '斗罗大陆', '流浪地球2'].map((tag) => (
            <button
              key={tag}
              onClick={() => window.REACT_APP_NAVIGATE(`/category/all?search=${encodeURIComponent(tag)}`)}
              className="px-3 py-1 text-xs rounded-full bg-background-50/40 text-foreground-400 hover:text-primary-400 hover:bg-background-50/60 border border-background-200/50 transition-colors whitespace-nowrap cursor-pointer"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}